export default {
      id: "ic-plan-mairie-usage",
      viewBox: "0 0 40 40",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#ic-plan-mairie-usage",
      toString: function () {
        return this.url;
      }
    }